export default __webpack_public_path__ + "static/media/email.bea537ca.svg";